var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Axios from 'axios';
import { getBrowserCultureLang } from '@singleton-i18n/js-core-sdk';
var identity = function (args) { return args; };
function createClient(defaultConfig) {
    if (defaultConfig === void 0) { defaultConfig = {}; }
    var interceptors = defaultConfig.interceptors, axiosRequestConfig = __rest(defaultConfig, ["interceptors"]);
    var instance = Axios.create(axiosRequestConfig);
    if (interceptors) {
        if (interceptors.request) {
            instance.interceptors.request.use(interceptors.request.config || identity, interceptors.request.error || identity);
        }
        if (interceptors.response) {
            instance.interceptors.response.use(interceptors.response.data || identity, interceptors.response.error || identity);
        }
    }
    function get(url, config) {
        return new Promise(function (resolve, reject) {
            instance.get(url, config).then(function (axiosResponse) {
                var data = axiosResponse.data, status = axiosResponse.status, headers = axiosResponse.headers;
                resolve({
                    data: data,
                    status: status,
                    headers: headers
                });
            }, reject);
        });
    }
    function post(url, data, config) {
        return new Promise(function (resolve, reject) {
            instance.post(url, data, config).then(function (axiosResponse) {
                var responseData = axiosResponse.data, status = axiosResponse.status, headers = axiosResponse.headers;
                resolve({
                    data: responseData,
                    status: status,
                    headers: headers
                });
            }, reject);
        });
    }
    function put(url, data, config) {
        return new Promise(function (resolve, reject) {
            instance.put(url, data, config).then(function (axiosResponse) {
                var responseData = axiosResponse.data, status = axiosResponse.status, headers = axiosResponse.headers;
                resolve({
                    data: responseData,
                    status: status,
                    headers: headers
                });
            }, reject);
        });
    }
    function patch(url, data, config) {
        return new Promise(function (resolve, reject) {
            instance.patch(url, data, config).then(function (axiosResponse) {
                var responseData = axiosResponse.data, status = axiosResponse.status, headers = axiosResponse.headers;
                resolve({
                    data: responseData,
                    status: status,
                    headers: headers
                });
            }, reject);
        });
    }
    function del(url, config) {
        return new Promise(function (resolve, reject) {
            instance.delete(url, config).then(function (axiosResponse) {
                var data = axiosResponse.data, status = axiosResponse.status, headers = axiosResponse.headers;
                resolve({
                    data: data,
                    status: status,
                    headers: headers
                });
            }, reject);
        });
    }
    return {
        get: get,
        post: post,
        put: put,
        patch: patch,
        delete: del
    };
}
var ResponseEvtInterceptorBuilder = function () {
    var listeners = [];
    return {
        listen: function (listener) {
            listeners = __spreadArrays(listeners, [listener]);
            return function () { return (listeners = listeners.filter(function (l) { return l !== listener; })); };
        },
        push: function (data, error) {
            return listeners.forEach(function (listener) { return listener(data, error); });
        }
    };
};
var responseEvtInterceptor = ResponseEvtInterceptorBuilder();
export var forbiddenResponseRedirectEffect = function (navigateToLoginPage) {
    var deactivateFn = function () {
        /** */
    };
    var activate = function () {
        return responseEvtInterceptor.listen(function (axiosResponse, error) {
            if (error && error.response) {
                var config = error.response.config;
                if (!(config && config.url.startsWith('/lcm/locker/api/passwords/view')) &&
                    !(config && config.url.startsWith('/lcm/lcops/api/v2/environments')) &&
                    !(config &&
                        config.url.startsWith('/lcm/lcops/api/settings/telemetrysettings')) &&
                    !(config &&
                        config.url.startsWith('/lcm/lcops/api/environments') &&
                        config.url.endsWith('products/vra/nodes'))) {
                    if (error.response.status === 401 || error.response.status === 403) {
                        // eslint-disable-next-line
                        console.warn("API call response Interceptor:: returned 401 or 403 response,\n                hence redirecting to login page. response - ", axiosResponse);
                        navigateToLoginPage();
                    }
                }
            }
        });
    };
    return {
        activate: function () { return (deactivateFn = activate()); },
        deactivate: function () { return deactivateFn(); }
    };
};
export var serverUnreachableHandlerEffect = function (callback) {
    var deactivateFn = function () {
        /** */
    };
    var activate = function () {
        return responseEvtInterceptor.listen(function (_, error) {
            if (error && error.response.status === 502) {
                // eslint-disable-next-line
                console.warn("Server unreachable call response Interceptor:: returned error", error);
                callback();
            }
        });
    };
    return {
        activate: function () { return (deactivateFn = activate()); },
        deactivate: function () { return deactivateFn(); }
    };
};
export var Http = createClient({
    interceptors: {
        request: {
            config: function (config) {
                config.headers['Accept-Language'] =
                    localStorage.getItem('locale') || getBrowserCultureLang() || 'en';
                return config;
            }
        },
        response: {
            data: function (data) {
                responseEvtInterceptor.push(data);
                return data;
            },
            error: function (error) {
                responseEvtInterceptor.push(undefined, error);
                return Promise.reject(error);
            }
        }
    }
});
